import { render } from "./CopyLinkButton.vue?vue&type=template&id=13fb0136&scoped=true&ts=true"
import script from "./CopyLinkButton.vue?vue&type=script&lang=ts"
export * from "./CopyLinkButton.vue?vue&type=script&lang=ts"

import "./CopyLinkButton.vue?vue&type=style&index=0&id=13fb0136&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fb0136"]])

export default __exports__